import React from 'react';
import { useRecoilValue } from 'recoil';
import { Box } from '@mui/material';
import { annotationState } from 'features/three-view/state/threeAtoms';
import { projectionModeState } from '../state/viewModeAtoms';
import { annotationTitleToLabel } from '../utils/annotationLabel';

export const ViewLabel: React.FC = () => {
  const projectionMode = useRecoilValue(projectionModeState);
  const annotation = useRecoilValue(annotationState);

  const projectionText = projectionMode === 'perspective' ? 'Perspective' : 'Orthographic';
  const directionText = annotationTitleToLabel(annotation.title);

  return (
    <Box
      component="div"
      data-testid="view-label"
      role="status"
      aria-live="polite"
      sx={{
        position: 'absolute',
        top: 8,
        left: 8,
        zIndex: 1000,
        padding: '4px 10px',
        backgroundColor: 'rgba(0, 0, 0, 0.55)',
        color: 'white',
        fontFamily: 'monospace',
        fontSize: '0.75rem',
        borderRadius: 1,
        pointerEvents: 'none',
        userSelect: 'none',
      }}
    >
      {projectionText} · {directionText}
    </Box>
  );
};
